import { CellContext, ColumnHelper, OnChangeFn, PaginationState, Row } from "@tanstack/react-table";
import { ObjectState } from "../../../../containers/centralView/taskListView/types/tasklListViewProps";
import { SharedProps } from "../../types/SharedProps";

export type TableProps = SharedProps & {
    columnHelper: ColumnHelper<any>;
    columnAliases?: any;
    columnNames?: string[];
    columnConfig?: ColumnConfig[];
    cellWidth?: {[key: string]: string};
    cellActions?: (properties: CellContext<any, unknown>) => JSX.Element;
    startCellAction?: (properties: CellContext<any, unknown>) => JSX.Element;
    data: any[];
    loading: boolean;
    mockUp?: boolean;
    selection?: __esri.Graphic[];
    extraSelection?: __esri.Graphic[];
    stopSelection?: boolean;
    onTrClick?: (features: __esri.Graphic[]) => void;
    rowCompare?: (feature: __esri.Graphic, row: Row<any>) => boolean;
    compareId?: (row1: Row<any>, row2: Row<any>) => boolean;
    firstColumnCheckbox?: boolean;
    tableFiltersVisible?: boolean;
    draggableRows?: boolean;
    handleReorderRows?: any;
    threeDots?: boolean;
    threeDotsProps?: ThreeDotsProps;
    foldoutRows?: boolean;
    rowsToFoldOut?: string[];
    foldoutContent?: Function;
    foldoutParamToCheck?: Function;
    tableError?: boolean;
    tableErrorMsg?: string;
    errorRows?: string[];
    errorRowsMsg?: string;
    highlightFunc?: (row: Row<any>) => boolean;
    setCommentsFilter?: any;
    checkIfMarkedForCommentFilter?: any;
    isTrClickable?: boolean;
    narrowTableForCommentBtns?: boolean;
    shiftSelection?: boolean;
    refocus?: boolean;
    setRefocusTable?: Function;
    scrollable?: boolean;

    //pagination
    isPagination?: boolean,
    pagination?: PaginationState,
    setPagination?: OnChangeFn<PaginationState>,
    allCount?: number,
    pageCount?: number,
    setPageCount?: any,
    onPaginationChange?: (name: string, value: any) => void
}

export type ColumnConfig = {
    name: string,
    type: ColumnType
}

export enum ColumnType {
    Text = 1,
    Number = 2,
    Date = 3
}

export type ThreeDotsProps = {
    table?: ThreeDotsTableTypes;
    menuStyle?: React.CSSProperties;
    menuItemClass?: string;
    editOnClick?: any;
    collectiveEditOnClick?: any;
    cancelOAndKOnClick?: any;
    cancelAAndNClick?: any,
    deleteKROnClick?: any;
    validateOnClick?: any;
    returnToWaitingRoomOnClick?: any;
    assignEditorOnClick?: any;
    assignVerifierOnClick?: any;
    cancelTaskOnClick?: any;
    previewOnClick?: any;
    approveDictProposalOnClick?: any;
    rejectDictProposalOnClick?: any;
    updateRecOnClick?: any;
    markStatus?: (status: ObjectState, objectType: string) => Promise<void>;
    automaticVerificationClick?: () => Promise<void>;
    downloadCardClick?: any;
    addProtocolOnClick?: any;
    ReturnCardClick?: () => Promise<void>;
 }

export enum ThreeDotsTableTypes {
    DataBase,
    TaskListWaiting,
    TaskListLocal,
    DictionaryProposals
}

